// client/src/components/HeroSection.js
import { VStack, Image, Text } from "@chakra-ui/react";


export default function HeroSection() {
    return (
        <VStack 
            spacing="clamp(16px, 1.2vw, 28px)"
            textAlign="center"
            align="center"
            mb="clamp(32px, 2.5vw, 50px)"
            mt="clamp(32px, 2.5vw, 50px)"
        >
            <Image
                src="/icon_hero.svg"
                alt="Engineering Assistant"
                width="clamp(175px, 12vw, 220px)" 
                borderRadius="100px"
            />

            <Text 
                fontSize="clamp(28px, 2.5vw, 48px)" 
                fontWeight="bold" 
                width="clamp(65%, 65%, 65%)"
                lineHeight="1.2" 
            >
                Analyze, optimize, prepare your design for fabrication
            </Text>

            <Text
                fontSize="clamp(14px, 1.1vw, 20px)" 
                fontWeight="medium"
                width="clamp(80%, 80%, 85%)" 
                color="#6D6D6D"
                lineHeight="1.6"
            >
                Alpherra analyzes geometry, materials, tolerances, and feasibility
                risks, giving you actionable suggestions for safer, stronger,
                production-ready designs.
            </Text>
        </VStack>
    );
}
